import { formatPrice } from '@lichtblick/localization';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { getLoyaltyBonusInEur, getLoyaltyBonusInPercent } from '@/components/card/card-utils';
import { PriceBreakdownList } from '@/components/price-breakdown/price-breakdown-list';
import { PriceBreakdownRow } from '@/components/price-breakdown/price-breakdown-row';
import type { TariffsQuery } from '@/types/generated';
import styles from './bonus.module.css';

export const BonusPriceSection = ({ product }: { product: TariffsQuery['tariffs'][number] }) => {
  const loyaltyBonusInEur = getLoyaltyBonusInEur(product);
  const instantBonusInEur = product?.bonus?.instantBonusInEur;
  const showBonusSection = Boolean(loyaltyBonusInEur ?? instantBonusInEur);

  if (!showBonusSection) {
    return null;
  }

  return (
    <PriceBreakdownList>
      {Boolean(instantBonusInEur) && (
        <PriceBreakdownRow isBonus label="Sofortbonus nach 60 Tagen" value={`-${formatPrice(instantBonusInEur)}`} />
      )}

      {Boolean(loyaltyBonusInEur) && (
        <PriceBreakdownRow isBonus label="Treuebonus nach 365 Tagen" value={`-${formatPrice(loyaltyBonusInEur)}`} />
      )}

      <PriceBreakdownRow isBold label="Kosten im Jahr (mit Bonus)" value={formatPrice(product.totalPrice)} />

      <PriceBreakdownRow
        isBold
        label="ø Kosten pro Monat (mit Bonus)"
        value={formatPrice(product.monthlyPriceWithBonus)}
      />
    </PriceBreakdownList>
  );
};

export const BonusParagraph = ({ product }: { product: TariffsQuery['tariffs'][number] }) => {
  const loyaltyBonusInEur = getLoyaltyBonusInEur(product);
  const loyaltyBonusInPercent = getLoyaltyBonusInPercent(product);
  const instantBonusInEur = product?.bonus?.instantBonusInEur;
  const showParagraphSection = Boolean(loyaltyBonusInEur && loyaltyBonusInPercent) || Boolean(instantBonusInEur);

  if (!showParagraphSection) {
    return null;
  }

  return (
    <div className={styles.bonus}>
      <Text bold size="s" className={styles.title}>
        Bonus Details
      </Text>

      {Boolean(instantBonusInEur) && (
        <Text size="xs">
          Als Dankeschön für dein Vertrauen erhältst du 60 Tage nach Lieferbeginn einen einmaligen <b>Sofortbonus</b>{' '}
          von {formatPrice(instantBonusInEur)}.
        </Text>
      )}

      {Boolean(loyaltyBonusInEur) && Boolean(loyaltyBonusInPercent) && (
        <Text size="xs">
          Deine Treue zahlt sich aus: Am Ende der ersten zwölf Liefermonate erhältst du einen prozentualen{' '}
          <b>Treuebonus</b> von {loyaltyBonusInPercent} % des Erstjahresgesamtpreises (voraussichtlich{' '}
          {formatPrice(loyaltyBonusInEur)}). Der Bonus wird auf Grundlage der bei Vertragsabschluss geltenden Preise,
          sowie deines tatsächlichen Energieverbrauchs berechnet und Dir gutgeschrieben.
        </Text>
      )}
    </div>
  );
};
